import React, { useEffect, useState } from 'react';
import TotpQrCode from '../components/TotpQrCode';
import { confirmTotp, getToken, setSession, setupTotp } from '../services/api';

const MfaSetup = ({ usuario, onMfaReady, onLogout }) => {
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    setupTotp()
      .then(setSetup)
      .catch((err) => setError(err.message || 'No se pudo iniciar la configuración MFA.'))
      .finally(() => setLoading(false));
  }, []);

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError('');
    if (code.length !== 6) {
      setError('Ingresa el código de 6 dígitos de tu authenticator.');
      return;
    }
    setConfirming(true);
    try {
      const data = await confirmTotp(code);
      setSession(getToken(), data.usuario);
      onMfaReady(data.usuario);
    } catch (err) {
      setError(err.message || 'Código authenticator inválido.');
    } finally {
      setConfirming(false);
    }
  };

  return (
    <main className="gv-password-required">
      <section className="gv-card gv-password-required__card">
        <div className="gv-password-required__brand">
          <img src="/logo-gv-azul-color.png" alt="GasValpo + energias" />
          <span>Seguridad obligatoria</span>
        </div>
        <h1>Activa doble factor</h1>
        <p>
          Hola {usuario?.nombre || 'usuario'}, por seguridad debes configurar un authenticator
          antes de acceder al sistema.
        </p>

        {error && <div className="gv-alert gv-alert--error">{error}</div>}
        {loading && <p className="import-empty">Generando clave de configuración...</p>}

        {setup && (
          <form noValidate onSubmit={handleConfirm} className="mfa-setup">
            <TotpQrCode value={setup.otpauth_url} />
            <div>
              <strong>Clave manual</strong>
              <code>{setup.secret}</code>
              <p>Abre Google Authenticator, Microsoft Authenticator u otra app TOTP y agrega esta clave manual.</p>
            </div>
            <div>
              <strong>URL authenticator</strong>
              <code>{setup.otpauth_url}</code>
            </div>
            <div className="gv-form-group">
              <label className="gv-label">Código de 6 dígitos</label>
              <input
                className="gv-input"
                inputMode="numeric"
                maxLength="6"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="123456"
                autoComplete="one-time-code"
                required
              />
            </div>
            <button type="submit" className="gv-btn gv-btn--primary gv-btn--full" disabled={confirming}>
              {confirming ? 'Validando...' : 'Activar y continuar'}
            </button>
            <button type="button" className="gv-btn gv-btn--ghost gv-btn--full" onClick={onLogout}>
              Salir
            </button>
          </form>
        )}
      </section>
    </main>
  );
};

export default MfaSetup;
